import {
  Currencies,
  DEPOSIT_ADDRESS_STATE,
  DEPOSIT_ADDRESS_TYPE,
} from "@letsbit/malcolmlb";
import { useGetDepositAddress } from "hooks/payments/useGetDepositAddress";
import { useWallets } from "hooks/user/useWallets";

export const useBridgeAccount = () => {
  const { data: wallets, isLoading: isLoadingWallets } = useWallets();
  const usdeeuuWallet = wallets?.["usdeeuu"];
  const bridgePN = usdeeuuWallet?.currency_networks.find((pn) =>
    pn.payment_network.id.includes("bridge"),
  )?.payment_network.id;
  const { data: depositAddressInformation, isLoading: isLoadingDA } =
    useGetDepositAddress(usdeeuuWallet?.id as Currencies, bridgePN);

  return {
    loading: isLoadingDA || isLoadingWallets,
    canHaveBridgeAccount: !!bridgePN,
    awaitingTos:
      depositAddressInformation &&
      depositAddressInformation.type ===
        DEPOSIT_ADDRESS_TYPE.PERSONAL_ACCOUNT_BRIDGE &&
      depositAddressInformation.data.state ===
        DEPOSIT_ADDRESS_STATE.AWAITING_TOS,
    usdeeuuWallet,
    bridgePN,
    depositAddressInformation:
      depositAddressInformation?.type ===
      DEPOSIT_ADDRESS_TYPE.PERSONAL_ACCOUNT_BRIDGE
        ? depositAddressInformation
        : undefined,
  };
};
